import { render } from "./ReportButton.vue?vue&type=template&id=63af144e&scoped=true"
import script from "./ReportButton.vue?vue&type=script&lang=js"
export * from "./ReportButton.vue?vue&type=script&lang=js"

import "./ReportButton.vue?vue&type=style&index=0&id=63af144e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63af144e"]])

export default __exports__